const signupMessages = {
  success: {
    title: "¡Felicidades!",
    content:
      "Has completado tu registro, en los próximos minutos estarás recibiendo un correo confirmando la creación de tu cuenta.",
    buttonContent: "Ir a Inicio de Sesión",
  },
  error: {
    title: "¡Ups!",
    content:
      "Ha ocurrido un error durante tu registro, puedes volver a intentarlo o contactar a:",
    foreignProp: "beneficios@deacero.com",
    buttonContent: "Intentar de nuevo",
  },
};

export default signupMessages;
